
import { Component, Vue, Prop } from 'vue-property-decorator'
import LocationMap from '@/components/maps/LocationMap.vue'
import { MarkerPosition } from '@/types//Maps'
import { TemplateQuestionsTypes } from '@/types/Fillgrid'
import moment from 'moment'

@Component({
  components: {
    LocationMap
  }
})
export default class Fillgrid extends Vue {
  @Prop()
  type: string

  @Prop()
  src: any

  MEDIA_TYPES = TemplateQuestionsTypes

  getMarker (location: any) {
    // If question was type photo, location must be extracted
    if (location && (location.location || (location.latitude && location.longitude))) {
      const latitude = location.location ? location.location.latitude : location.latitude
      const longitude = location.location ? location.location.longitude : location.longitude
      const label = location.label
      return new MarkerPosition(latitude, longitude, undefined, label)
    }
    return undefined
  }

  getDateFormatted (date: string) {
    return moment.utc(date).local().format('dddd D [de] MMMM [de] YYYY, [a las] HH:mm [hrs.]')
  }

  getLocationMarkers (locations: any) {
    return locations && locations
      .map((loc: any) => this.getMarker(loc))
      .filter(Boolean)
  }
}
